import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Header } from 'semantic-ui-react';
import { sysAPI } from '../../../../apis/SysAPI';
import { responseError } from '../../../../helpers';
import { useDispatch } from 'react-redux';
import { StackedGraphic } from '../../Graphics/Tables';
import Loading from '../../../../components/globals/Loading';
import { isDarkMode } from '../../../../components/settings/dark-mode/Toggle';

const GraphicValidVsInvalid = forwardRef(({ activeIndex, startDate, endDate, areas, loading, excludeCompanies, includeCompanies, setLoading }, ref) => {
    const dispatch = useDispatch();
    const [labels, setLabels] = useState([]);
    const [datasets, setDatasets] = useState([]);
    const [internalLoading, setIntenalLoading] = useState(false)

    const getData = async () => {
        setLoading(true);
        setIntenalLoading(true);
        try {
            const { data } = await sysAPI.get(`/metrics/tables/valid-vs-invalid-processes`, {
                params: {
                    startDate,
                    endDate,
                    areas: areas.join(','),
                    excludeCompanies: excludeCompanies.join(','),
                    includeCompanies: includeCompanies.join(','),
                },
            });
            setLabels(data?.data?.labels || []);
            setDatasets(data?.data?.datasets || []);
        } catch (error) {
            responseError(error, undefined, 'GraphicValidVsInvalid.getData', dispatch);
        }
        setLoading(false);
        setIntenalLoading(false);
    };

    useImperativeHandle(ref, () => ({
        getData: getData,
    }));

    useEffect(() => {
        getData();

        // eslint-disable-next-line
    }, [activeIndex]);
    const isDarkModeEnable = isDarkMode()

    const options = { barPercentage: 0.3, indexAxis: 'y', elements: { bar: { borderWidth: 2, borderColor: isDarkModeEnable ?'#fff' : "#000" } } }
    const plugins = { legend: { display: true, position: 'bottom', labels: { font: { size: 15 }, color: isDarkModeEnable ? '#fff' : '#000', } } }
    return (
        <div className='card_metrics'>
            {internalLoading ? <>
                <Loading />
            </> : <>
                <Header textAlign="center" as="h3">
                    Valid Vs Invalid Processes
                </Header>
                <div>
                    <StackedGraphic
                        labels={labels}
                        datasets={datasets}
                        options={options}
                        plugins={plugins}
                    />
                </div>
            </>}
        </div>
    );
});

export default GraphicValidVsInvalid;
